import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[appConsentIcon]',
    standalone: false
})
export class ConsentIconDirective {

  @Input() set accepted(value: boolean) {
    this.iconType = this.getIconType(value)
    this.color = this.getColor(value)
  }

  @HostBinding('innerHTML') iconType = '';
  @HostBinding('style.color') color = ''

  constructor() { }

  private getIconType(value: boolean): string {
    if (value)
      return 'check_circle'
    else return 'cancel'
  }

  private getColor(value: boolean): string {
    if (value) return '#65ad3c'
    else return '#ff463c'
  }

}
